<div class="btn-group col-12">

  <ng-container *ngFor="let option of props.options | formlySelectOptions : field | async; let i = index">

    <input type="radio"
      [formControl]="option.disabled ? disabledControl : formControl"
      [formlyAttributes]="field"
      class="btn-check"
      [id]="id + '_' + i"
      [name]="field.name || id"
      [class.is-invalid]="showError"
      [value]="option.value"
      (change)="props.change" />
    <label class="btn btn-outline-primary text-center col p-1"
      [class.btn-outline-danger]="showError"
      [for]="id + '_' + i"
      [innerHTML]="option.label">
    </label>

  </ng-container>

</div>